module.exports = __webpack_public_path__ + "static/img/mountains.13ef2c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mountains.jpg
// module id = 26
// module chunks = 1